import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, sub, testId }) => (
  <div className="max-w-3xl" data-testid={testId}>
    <Reveal>
      <p className="text-xs sm:text-sm font-mono font-semibold tracking-[0.25em] uppercase text-cyan-400">
        {kicker}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.12] text-slate-50">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{sub}</p>
      </Reveal>
    )}
  </div>
);
